import { useTranslator } from "@eo-locale/react";

import {
  HStack,
  Text,
  Link,
  IconButton,
  FiFacebook,
  AiOutlineGoogle
} from "@/storybook-components";
import { useAppSelector } from "@/redux/store/hooks";

const SocialSignIn = (): JSX.Element => {
  const { translate } = useTranslator();
  const { participationConfigurations } = useAppSelector(
    (state) => state.participationConfigurations
  );

  const { googleEnabled, facebookEnabled } = participationConfigurations;

  if (!googleEnabled && !facebookEnabled) return null;

  return (
    <HStack mt={4} justify="center">
      <Text>{translate("login.orContinueWith")}</Text>
      {googleEnabled && (
        <IconButton
          as={Link}
          round
          variant="social"
          target="_blank"
          rel="noopener noreferrer"
          colorPalette="red"
          href="/auth/google_oauth2"
          icon={<AiOutlineGoogle />}
          aria-label={translate("common.socialMedia.google")}
          data-testid="login-participant-button-social-google"
        />
      )}
      {facebookEnabled && (
        <IconButton
          round
          as={Link}
          variant="social"
          target="_blank"
          rel="noopener noreferrer"
          colorPalette="facebook"
          icon={<FiFacebook />}
          href="/auth/facebook"
          aria-label={translate("common.socialMedia.facebook")}
          data-testid="login-participant-button-social-facebook"
        />
      )}
    </HStack>
  );
};

export default SocialSignIn;
